<template>
    <el-drawer title="乐迷详情" :visible.sync="detailVisible" :before-close="closeDialog" size="600px">
        <div class="drawer-content"  v-loading="pageLoading">
            <ul class="info-content">
                <li><span class="title">头像</span>
                    <span>
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="detailForm.avatar">
                        </el-image>
                    </span>
                </li>
                <li>
                    <span class="title">ID</span>
                    <span>{{ detailForm.id }}</span>
                </li>
                <li>
                    <span class="title">用户名</span>
                    <span>{{ detailForm.name }}</span>
                </li>
                <li>
                    <span class="title">账号性别</span>
                    <span>{{ detailForm.sex == 1 ? '男' : detailForm.sex == 2 ? '女' : '未知' }}</span>
                </li>
                <li>
                    <span class="title">账号生日</span>
                    <span>{{ detailForm.birthday }}</span>
                </li>
                <li>
                    <span class="title">手机号</span>
                    <span v-if="detailForm.telephone">{{ ` ${detailForm.areaCode && detailForm.areaCode.split('_')[0]} ${detailForm.telephone}`}}</span>
                </li>
                <li>
                    <span class="title">账号标签</span>
                    <span>{{ detailForm.tagVOS && detailForm.tagVOS.map(i=> i.styleName).join('/') }}</span>
                </li>
                <li>
                    <span class="title">个性签名</span>
                    <span>{{ detailForm.signature }}</span>
                </li>
                <li>
                    <span class="title">注册时间</span>
                    <span>{{ detailForm.registTime }}</span>
                </li>
                <li>
                    <span class="title">来源渠道</span>
                    <span>{{ detailForm.source && sourceMap.get(detailForm.source) }}</span>
                </li>
                <li>
                    <span class="title">注册终端</span>
                    <span>{{ detailForm.terminal && terminalMap.get(detailForm.terminal) }}</span>
                </li>
                <li>
                    <span class="title">最近登录时间</span>
                    <span>{{ detailForm.lastLoginTime }}</span>
                </li>
                <li>
                    <span class="title">最近登录城市</span>
                    <span>{{ detailForm.lastLoginCityName }}</span>
                </li>
                <li>
                    <span class="title">支付订单数</span>
                    <span>{{ detailForm.orders }}</span>
                </li>
                <li class="last">
                    <span class="title">实名信息</span>
                    <div class="div">
                        <span v-if="detailForm.authority == 0"><el-link  @click="toRealnameManage(detailForm.id)">无</el-link></span>
                        <template v-else>
                            <span v-if="$utils.have('/commonPerformer/search')"><el-link  @click="toRealnameManage(detailForm.id)">点击管理</el-link></span>
                            <span v-else>无权限管理</span>                            
                        </template>
                    </div>                    
                </li>
            </ul>
        </div>
        <div class="drawer-footer">
            <el-button  v-if="$utils.have('/userPunish/search')" type="danger" @click="toPunish">处罚</el-button>
            <el-button @click="closeDialog">关 闭</el-button>
        </div>
    </el-drawer>
</template>
<script>
import {dataMap} from './mixins';
export default {
    mixins: [dataMap],
    props: {
        detailVisible: {
            type: Boolean,
            default: false
        },
        detailId: {
            type: [Number, String],
            default: null
        }
    },
    watch: {
        detailId(n){
            this.getInfo(n);
        }
    },
    data(){
        return {
            pageLoading: true,
            detailForm: {}                 
        }
    },
    methods: {
        getInfo(id){
            this.pageLoading = true;
            this.$request({
                url: '/fans/manger/detail',
                method: "POST",
                data: {id}
            }).then(res=>{
                const {state, msg, result} = res.data;
                if (state == 1) {
                    this.detailForm = {...result};
                } else {
                    this.$message.error(msg || "请求失败");
                }
            }).catch(() => {
                this.$message.error("请求错误");
            }).finally(()=>{
                this.pageLoading = false;
            })
        },
        closeDialog(){
            this.$emit('update:detailVisible', false);      
        },
        toRealnameManage(id){
            this.$router.push({path: '/user/realName/list', query: {id}})
        },
        toPunish(){
            this.$router.push({path: '/user/punish/list', query: {id: this.detailId}})
        }
    }
}
</script>
<style lang="scss" scoped>
.info-content{
    padding-bottom: 20px;
    &>li{
        display: flex;
        border: 1px solid #dcdfe6;
        &:not(.last){
            border-bottom: none;
        }
        span{
            padding: 16px; 
        }
        .div{
            padding: 16px 0;
        }
        .title{                  
            width: 120px;
            box-sizing: border-box;
            background: #f5f7fa;
            border-right: 1px solid #dcdfe6;
            flex-shrink: 0;
        }
    }
    
}
</style>